// extracted by mini-css-extract-plugin
export var addViewLink = "_x-1";
export var availabilityIcon = "_x-16";
export var availabilitySelectionIcon = "_x-15";
export var backButton = "_x-2";
export var backIcon = "_x-z";
export var conversationCount = "_x-3";
export var dragHandle = "_x-5";
export var dropdown = "_x-e";
export var dropdownIcon = "_x-7";
export var dropdownOption = "_x-6";
export var dropdownTriangle = "_x-d";
export var expand = "_x-f";
export var folder = "_x-i";
export var folderItem = "_x-c";
export var icon = "_x-8";
export var iconRow = "_x-9";
export var image = "_x-a";
export var logo = "_x-b";
export var navContainer = "_x-h";
export var navigationFooter = "_x-g";
export var pageShell = "_x-0";
export var placeholderAvailable = "_x-11";
export var placeholderBox = "_x-14";
export var placeholderBusy = "_x-13";
export var placeholderUnavailable = "_x-12";
export var profile = "_x-k";
export var profileContainer = "_x-m";
export var profileDropdown = "_x-n";
export var profileImage = "_x-l";
export var profileMain = "_x-o";
export var profileSubtitle = "_x-q";
export var profileTitle = "_x-p";
export var reorderIcon = "_x-r";
export var sentLine = "_x-u";
export var settingsHeader = "_x-s";
export var sidenavTextColor = "_x-y";
export var spamLine = "_x-t";
export var subitemWithTag = "_x-4";
export var supportItems = "_x-j";
export var teamText = "_x-10";
export var viewLine = "_x-x";
export var viewLineButton = "_x-w";
export var viewLineButtons = "_x-v";